import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

// Define the search URL based on environment variables
const searchUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.searchProducts}`;
// const searchUrl = `https://api.amzio.de/api/user/category-list`;

const searchProducts = async (productData, lang) => {
  try {
    const authToken = localStorage.getItem("authToken");
    // Ensure the search query is always included in the request data
    const response = await axios.post(
      searchUrl,
      {
        ...productData, // Spread the productData to include search query, filters, etc.
        search: productData.search,
        category_id: productData.category_id,
        parent_category_id: productData.parent_category_id, // Explicitly pass the search query in the payload
        page: productData.page, // Explicitly pass the page number
        filters: productData.filters, // Pass the filters to the API
      },
      {
        headers: {
          lang: lang,
          ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
        },
      }
    );

    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error fetching search products:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

export default searchProducts;

const suggestionUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.productSuggestions}`;

export const getProductSuggestions = async (payload, lang) => {
  try {
    const authToken = localStorage.getItem("authToken");

    // Convert payload → FormData
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    const response = await axios.post(suggestionUrl, formData, {
      headers: {
        lang,
        ...(authToken ? { authorization: `Bearer ${authToken}` } : {}),
        "Content-Type": "multipart/form-data", // important
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching product suggestions:", error);
    throw error;
  }
};
